import { processFeatureProperties } from './util/props';
import { WFS_ID_KEY, WFS_FTR_ID_KEY } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';
import { getFilterAlternativesAsArray, filterFeaturesByAttribute } from 'oskari-frontend/bundles/mapping/mapmodule/util/vectorfeatures/filter';

const getFeatureId = (feature) => feature.id || feature.properties[WFS_ID_KEY] || feature.properties[WFS_FTR_ID_KEY];
export class ReqEventHandler {
    constructor (sandbox) {
        this.sandbox = sandbox;
        this.isClickResponsive = true;
    }

    createEventHandlers (plugin) {
        const me = this;
        const getSelectedLayer = (layerId) => this.sandbox.getMap().getSelectedLayer(layerId);
        const getSelectionService = () => this.sandbox.getService('Oskari.mapframework.service.VectorFeatureSelectionService');
        return {
            MapClickedEvent: (event) => {
                if (!me.isClickResponsive) {
                    return;
                }
                const hits = plugin.getMapModule().getFeaturesAtPixel(event.getMouseX(), event.getMouseY());
                const keepPrevious = event.getParams().ctrlKeyDown;
                const modifySelectionOpts = {};
                const getSelectionOptsForLayer = layer => {
                    let selectionOpts = modifySelectionOpts[layer.getId()];
                    if (!selectionOpts) {
                        selectionOpts = { layer, features: [] };
                        modifySelectionOpts[layer.getId()] = selectionOpts;
                    }
                    return selectionOpts;
                };
                // NBA customized
                hits.forEach(({ featureProperties, layerId }) => {
                    const layer = getSelectedLayer(layerId);
                    if (!layer || !plugin.isLayerSupported(layer)) {
                        return;
                    }
                    const registryLayers = Oskari.getSandbox().findRegisteredModuleInstance('nba-registers').conf.registryLayers;
                    const wfsFeatureId = featureProperties[WFS_ID_KEY];
                    const registry = registryLayers[layerId];
                    const ids = [];
                    const subIds = [];
                    const registryData = {
                        features: [],
                        layerId: layer.getId(),
                        lonlat: event.getLonLat(),
                        via: 'registry'
                    };
                    if(typeof registry !== 'undefined') {
                        if (typeof featureProperties[registry.mainIdAttribute] !== 'undefined') {
                            ids.push(featureProperties[registry.mainIdAttribute]);
                        }
                        if (typeof featureProperties[registry.subIdAttribute] !== 'undefined') {
                            subIds.push(featureProperties[registry.subIdAttribute]);
                        }
                    }
                    if (ids.length > 0) {
                        const handleResponse = (data) => {
                            if (data === 'null') {
                                return;
                            }

                            let features = [];
                            const itemType = registry.itemType;

                            if (!_.isArray(data)) {
                                data = [data];
                            }

                            if (itemType !== null && itemType !== '' && itemType !== 'main') {
                                data.forEach((value) => {
                                    var newFeatures = value[itemType].filter((el) => {
                                        return subIds.includes(el.id);
                                    });

                                    newFeatures.forEach((feature) => {
                                        // populate subItem with data from main object
                                        for (var attr in value) {
                                            if (value.hasOwnProperty(attr) && typeof feature[attr] === 'undefined') {
                                                feature[attr] = value[attr];
                                            }
                                        }
                                        feature.id = value.id; // show main feature id in infobox
                                    });
                                    features = features.concat(newFeatures);
                                });
                                if (features.length === 0) {
                                    features = data;
                                }
                            } else {
                                features = data;
                            }

                            registryData.features = features;
                            const WFSLayerService = Oskari.getSandbox().getService('Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService');
                            //WFSLayerService.emptyWFSFeatureSelections(layer);
                            var infoEvent = Oskari.eventBuilder('GetInfoResultEvent')(registryData);
                            Oskari.getSandbox().notifyAll(infoEvent);
                        };

                        jQuery.ajax({
                            url: Oskari.urls.getRoute('GetRegistryItems', { registerName: registry.name, id: ids.join() }),
                            type: 'GET',
                            success: function (data, textStatus, jqXHR) {
                                handleResponse(data);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                var loc = Oskari.getLocalization('nba-registers').gfiPopup;
                                var title = loc.errorTitle;
                                var message = loc.errorMessage;
                                var ok = loc.ok;
                                var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
                                var btn = dialog.createCloseButton(ok);
                                dialog.show(title, message, [btn]);

                                // when search for registry item data failed, then show normal GFI popup
                                if (keepPrevious) {
                                    getSelectionOptsForLayer(layer).features.push(wfsFeatureId);
                                } else {
                                    plugin.notify('GetInfoResultEvent', {
                                        layerId,
                                        features: [processFeatureProperties(featureProperties, true)],
                                        lonlat: event.getLonLat()
                                    });
                                }
                            }
                        });
                    } else {
                        if (keepPrevious) {
                            getSelectionOptsForLayer(layer).features.push(wfsFeatureId);
                        } else {
                            plugin.notify('GetInfoResultEvent', {
                                layerId,
                                features: [processFeatureProperties(featureProperties, true)],
                                lonlat: event.getLonLat()
                            });

                        }
                    }
                });
                if (keepPrevious) {
                    const service = getSelectionService();
                    if (service) {
                        Object.keys(modifySelectionOpts).forEach(layerId => {
                            modifySelectionOpts[layerId].features
                                .map(feat => feat.getId())
                                .forEach(featureId => service.toggleFeatureSelection(layerId, featureId));
                        });
                    }
                }
            },
            WFSSetFilter: (event) => {
                const service = getSelectionService();
                if (!service) {
                    return;
                }
                const keepPrevious = Oskari.ctrlKeyDown();
                const featureCollection = event.getGeoJson();
                const filterFeature = featureCollection.features[0];
                if (['Polygon', 'MultiPolygon'].indexOf(filterFeature.geometry.type) >= 0 && typeof filterFeature.properties.area !== 'number') {
                    return;
                }
                var targetLayers;
                if (plugin.WFSLayerService.getAnalysisWFSLayerId()) {
                    targetLayers = [plugin.WFSLayerService.getAnalysisWFSLayerId()];
                } else {
                    if (event.selectFromAllLayers()) {
                        targetLayers = plugin.getAllLayerIds();
                    } else {
                        const layerId = plugin.WFSLayerService.getTopWFSLayer();
                        targetLayers = layerId ? [layerId] : [];
                    }
                }
                const featuresResult = plugin.getFeatures({
                    geometry: filterFeature.geometry
                }, {
                    layers: targetLayers
                });
                Object.keys(featuresResult).forEach(layerId => {
                    const layerFeatures = featuresResult[layerId].features || [];
                    const selectedFeatureIds = layerFeatures.map(getFeatureId);

                    if (keepPrevious) {
                        selectedFeatureIds.forEach(id => service.addSelectedFeature(layerId, id));
                    } else {
                        service.setSelectedFeatureIds(layerId, selectedFeatureIds);
                    }
                });
            },
            WFSSetPropertyFilter: event => {
                if (!event.getFilters() || event.getFilters().filters.length === 0) {
                    return;
                }
                const service = getSelectionService();
                if (!service) {
                    return;
                }
                const layerId = event.getLayerId();
                const featuresResult = plugin.getFeatures(null, { layers: [layerId] });
                const records = featuresResult[layerId].features || [];
                if (!records.length) {
                    return;
                }
                const filteredIds = new Set();
                // filters is an object with key "filters" that we actually want to process...
                const { filters = [] } = event.getFilters();
                const alternatives = getFilterAlternativesAsArray(filters);
                alternatives.forEach(attributeFilters => {
                    let filteredList = records;
                    attributeFilters.forEach(filter => {
                        filteredList = filterFeaturesByAttribute(filteredList, filter);
                    });
                    filteredList
                        .map(getFeatureId)
                        .filter(id => !!id)
                        .forEach(id => filteredIds.add(id));
                });
                service.setSelectedFeatureIds(layerId, [...filteredIds]);
            }
        };
    }

    createRequestHandlers () {
        return {
            'WfsLayerPlugin.ActivateHighlightRequest': this
        };
    }

    // handle WfsLayerPlugin.ActivateHighlightRequest
    handleRequest (oskariCore, request) {
        this.isClickResponsive = request.isEnabled();
    }
}
